import { Box, FormControlLabel, ListItemIcon, Radio, Typography, useTheme } from "@mui/material";
import type { JSX } from "react";
import { useMemo } from "react";
import type { CustomFormatOption } from "./FormatType";

interface Props {
  formatType: CustomFormatOption;
  currentFormatType?: CustomFormatOption;
  disabled?: boolean;
  icon: JSX.Element;
}

export const FormatTypeItem = ({ formatType, currentFormatType, disabled, icon }: Props) => {
  const theme = useTheme();

  const selected = useMemo(() => {
    return formatType === currentFormatType;
  }, [formatType, currentFormatType]);

  const selectionColor = useMemo(() => {
    if (disabled) {
      return "inherit";
    }
    return selected ? theme.palette.primary.main : theme.palette.text.primary;
  }, [selected, disabled, theme]);

  return (
    <FormControlLabel
      sx={{
        color: selectionColor,
      }}
      value={formatType}
      control={<Radio disabled={!!disabled} sx={{ p: "4px" }} />}
      label={
        <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", pl: "5px" }}>
          <ListItemIcon sx={{ minWidth: "25px", color: selectionColor }}>{icon}</ListItemIcon>
          <Typography>{formatType}</Typography>
        </Box>
      }
    />
  );
};

export default FormatTypeItem;
